export const featureName = 'shop';